/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import DataTable from "../../../components/DataTable";
import { useListAllOsSoftware } from "../../../api/softwareImages";
import { useSubmitOsPatchRequestDialog } from "../Dialogs/SubmitOsPatchRequestDialog";
import { useNavigate } from "react-router-dom";
import styles from "../styles";

const Os = ({ engine, releaseBranch, displayNotification, reloadToggle }) => {
  const navigate = useNavigate();

  const [os, setOs] = useState([]);

  const { submitOsPatchRequestDialog, setOpenSubmitOsPatchRequestDialog } =
    useSubmitOsPatchRequestDialog(
      () => navigate(`/apps/tessell/software-images/os/builds`),
      displayNotification
    );

  const {
    postData: listAllOs,
    response: listAllOsResp,
    isLoading: isLoadingOs,
  } = useListAllOsSoftware(engine, releaseBranch);

  useEffect(() => {
    listAllOs();
  }, [engine, releaseBranch, reloadToggle]);

  useEffect(() => {
    if (Array.isArray(listAllOsResp?.os)) {
      setOs(listAllOsResp.os);
    } else {
      setOs([]);
    }
  }, [listAllOsResp]);

  const columns = [
    {
      field: "osVersionName",
      renderHeader: () => "Version Name",
      flex: 2,
      cellClassName: "name-column--cell",
      renderCell: ({ row: { osVersionName } }) => osVersionName || "",
    },
    {
      field: "osName",
      flex: 2,
      renderHeader: () => "OS Name",
      renderCell: ({ row: { osName } }) => osName ?? "",
    },
    {
      field: "osVersion",
      flex: 2,
      renderHeader: () => "Version",
      renderCell: ({ row: { osVersion } }) => osVersion ?? "",
    },
    {
      field: "actions",
      type: "actions",
      width: 56,
      getActions: ({ row }) => [
        <GridActionsCellItem
          label="Submit Patch Request"
          onClick={() => {
            setOpenSubmitOsPatchRequestDialog(
              {
                engine: engine,
                releaseBranch: releaseBranch,
                osName: row?.osName,
                oldVersion: row?.osVersion,
                oldVersionName: row?.osVersionName,
                dbSoftware: row?.dbSoftware,
              },
              Object.keys(row?.clouds)
            );
          }}
          showInMenu
        />,
      ],
    },
  ];

  return (
    <>
      {submitOsPatchRequestDialog}
      <DataTable
        height="100%"
        sx={styles.viewTable}
        getRowId={(row) => row?.osVersionName}
        loading={isLoadingOs}
        rows={os}
        columns={columns}
      />
    </>
  );
};

export default Os;
